import Vue from 'vue';
import App from './App.vue';
import router from './config/router';
import store from './config/store';
import i18n from './config/i18n';
import './config/filters';
import './config/font_awesome';
import './config/moment';
import './config/media_query';
import './config/mixins';
import './config/inputmask';
import './config/form-validation';


Vue.config.productionTip = false;
Vue.prototype.$isDev = process.env.NODE_ENV === 'development';

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
